import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';

class FuelTypeSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelTypesSelectOptions: [],
      isLoading: true,
    };

    this.selectChange = this.selectChange.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();
    const endPoint = 'v1/fuel_types';

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }, true).then((response) => {
      const fuelTypes = response.fuelTypes;

      Api.cache(endPoint, response);

      const fuelTypesSelectOptions = [];
      fuelTypes.map(fuelType =>
        fuelTypesSelectOptions.push({ value: fuelType.id, label: fuelType.name }));

      console.log(fuelTypesSelectOptions);

      this.setState({ fuelTypesSelectOptions, isLoading: false });
    });
  }

  selectChange(inputValue) {
    const value = inputValue === null ? inputValue : inputValue.value;
    this.props.onSelectChange(value);
  }

  render() {
    return (
      <Select
        id="fuelTypeId"
        name="fuel-type-select"
        value={this.props.selectedValue}
        isLoading={this.state.isLoading}
        options={this.state.fuelTypesSelectOptions}
        onChange={this.selectChange}
        clearable={true}
      />
    );
  }
}

FuelTypeSelect.propTypes = {
  onSelectChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.number.isRequired,
};

export default FuelTypeSelect;



// WEBPACK FOOTER //
// ./src/Containers/FuelTypes/FuelTypeSelect.js